module.exports = __webpack_public_path__ + "static/media/inbox.628aa1d4.svg";